import { CUSTOMER_SAW_ON } from '../../constants';
import { formatSeenDate } from '../utils/tradeInSeenFormat';
import { DealPulseAnchorStyle } from './DealPulseRow.style';

type TradeInIntelligenceSeenAnchorProps = {
    seenAt: string;
};

const TradeInIntelligenceSeenAnchor = ({ seenAt }: TradeInIntelligenceSeenAnchorProps) => (
    <DealPulseAnchorStyle data-testid="trade-in-intelligence-seen">
        {CUSTOMER_SAW_ON} {formatSeenDate(seenAt)}
    </DealPulseAnchorStyle>
);

export default TradeInIntelligenceSeenAnchor;
